import { create } from 'zustand';

const useStoreListUser = create((set) => ({
  isModalListUser: false,
  setIsModalListUser: () =>
    set((state) => ({ isModalListUser: !state.isModalListUser })),
}));

export default useStoreListUser;
